export default {
  Received: "Received",
  Sent: "Sent",
  ReceivedFiltered: "ReceivedFiltered",
};
